// extracted by mini-css-extract-plugin
module.exports = {"QRCamContainer":"qr-cam_QRCamContainer__1g_tN","text":"qr-cam_text__1g0YN"};